


<img src="../../../assets/images/check-green.gif">
<div class="align">
    <h2 style="color: rgb(3, 207, 3);">New Payment Link Created Successfully</h2>
</div>

<div class="buttonRow">
    <button mat-raised-button class="button" type="button" (click)="onNoClick()" (click)="onClick()">
       View payment link</button>
    <button mat-raised-button color="basic" class="buttonReset" type="button" [routerLink]="['/All/payment']" (click)="onNoClick()" style="margin-left: 10px;">Close</button>
  </div>

